import { Tooltip, Box } from "@mui/material";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import type { ITranslationItem } from "features/workspaces/types";

export const ItemStatus = ({ title, data }: { title?: string; data: ITranslationItem }) => {
  const errors = [];

  if (title) {
    errors.push(title);
  }

  if (!data?.isApproved) {
    errors.push("Original item is not Approved");
  }

  if (!data?.enabledToTranslate) {
    errors.push("not_valid");
  }

  const errorsText = errors.join("\n");
  const titleElement = <Box sx={{ whiteSpace: "pre-line" }}>{errorsText}</Box>;

  return errors.length ? (
    <Box sx={{ ml: -1, mr: 1 }}>
      <Tooltip title={titleElement}>
        <ExclamationTriangleIcon width={20} height={20} className="status--error" />
      </Tooltip>
    </Box>
  ) : null;
};
